export const frontmatter = {
  title: "Brand Kit",
  order: 14,
}


# Brand Kit

> A new brand kit will be uploaded soon! Please ask in Discord.
